<div class="bg-gray-50 min-h-screen">
  <div class="w-full px-4">
    <feature-mediator #mediator
      [rootDataProvider]="getPointOfServices"
      [level1DataProviders]="level1Providers"
      [nestedListTypes]="nestedListTypes"
      [shouldFetchLookupsOnRootSelect]="shouldFetchLookupsOnRootSelect">

      <!-- Sélection du client : tableau ou stack selon permissions -->
      @if(HasRequiredClientPermissions) {
      <app-client-list [featureContext]="'visitor'"
        [includedEntities]="mediator.entityNames()"
        (itemSelected)="onClientSelected($event)">
      </app-client-list>
      }
      @else if (HasRequiredTenantPermissions) {
      <app-client-stack [featureContext]="'visitor'"
        [includedEntities]="mediator.entityNames()"
        (itemSelected)="onClientSelected($event)">
      </app-client-stack>
      }

      <!-- Affichage des listes uniquement si un client est sélectionné -->
      @if (mediator.hasRootSelected) {
      <!-- Points de service -->
      <app-point-of-service-list [isNested]="true"
        [nestedData]="pointOfServices()"
        (itemSelected)="mediator.selectLevel1($event)">
      </app-point-of-service-list>

      <!-- Onglets Visites / Deliveries -->
      <div class="flex justify-end -mb-10 -mt-6">
        <div class="flex gap-1 bg-gray-100 rounded-lg px-1 pt-1 w-fit">
          <button class="px-4 py-1.5 mb-0 text-sm font-medium transition-all duration-200"
            [class.bg-white]="selectedFeatureTab() === 'visits'"
            [class.rounded-t-md]="selectedFeatureTab() === 'visits'"
            [class.rounded-b-none]="selectedFeatureTab() === 'visits'"
            [class]="{'shadow-[0_-2px_4px_rgba(0,0,0,0.08)]': selectedFeatureTab() === 'visits'}"
            [class.text-blue-600]="selectedFeatureTab() === 'visits'"
            [class.text-gray-500]="selectedFeatureTab() !== 'visits'"
            [class.rounded-md]="selectedFeatureTab() !== 'visits'"
            [class.hover:text-gray-700]="selectedFeatureTab() !== 'visits'"
            (click)="selectedFeatureTab.set('visits')">
            {{ 'vues.visitor-feature.tabs.visits' | translate }}
          </button>
          <button class="px-4 py-1.5 mb-0 text-sm font-medium transition-all duration-200"
            [class.bg-white]="selectedFeatureTab() === 'deliveries'"
            [class.rounded-t-md]="selectedFeatureTab() === 'deliveries'"
            [class.rounded-b-none]="selectedFeatureTab() === 'deliveries'"
            [class]="{'shadow-[0_-2px_4px_rgba(0,0,0,0.08)]': selectedFeatureTab() === 'deliveries'}"
            [class.text-blue-600]="selectedFeatureTab() === 'deliveries'"
            [class.text-gray-500]="selectedFeatureTab() !== 'deliveries'"
            [class.rounded-md]="selectedFeatureTab() !== 'deliveries'"
            [class.hover:text-gray-700]="selectedFeatureTab() !== 'deliveries'"
            (click)="selectedFeatureTab.set('deliveries')">
            {{ 'vues.visitor-feature.tabs.deliveries' | translate }}
          </button>
          <button class="px-4 py-1.5 mb-0 text-sm font-medium transition-all duration-200"
            [class.bg-white]="selectedFeatureTab() === 'buzzers'"
            [class.rounded-t-md]="selectedFeatureTab() === 'buzzers'"
            [class.rounded-b-none]="selectedFeatureTab() === 'buzzers'"
            [class]="{'shadow-[0_-2px_4px_rgba(0,0,0,0.08)]': selectedFeatureTab() === 'buzzers'}"
            [class.text-blue-600]="selectedFeatureTab() === 'buzzers'"
            [class.text-gray-500]="selectedFeatureTab() !== 'buzzers'"
            [class.rounded-md]="selectedFeatureTab() !== 'buzzers'"
            [class.hover:text-gray-700]="selectedFeatureTab() !== 'buzzers'"
            (click)="selectedFeatureTab.set('buzzers')">
            {{ 'vues.visitor-feature.tabs.buzzers' | translate }}
          </button>
        </div>
      </div>

      <!-- Visites (onglet Visits) -->
      @if (selectedFeatureTab() === 'visits') {
      <app-visit-list [isNested]="true" [nestedData]="visits()"
        [fkPointOfServiceId]="selectedPOS()?.id ?? null"></app-visit-list>
      }

      <!-- Deliveries (onglet Deliveries) -->
      @if (selectedFeatureTab() === 'deliveries') {
      <app-delivery-list [isNested]="true" [nestedData]="deliveries()"
        [fkPointOfServiceId]="selectedPOS()?.id ?? null"></app-delivery-list>
      }

      <!-- Buzzers (onglet Buzzers) -->
      @if (selectedFeatureTab() === 'buzzers') {
      <app-buzzer-config-list [isNested]="true" [nestedData]="buzzerConfigs()"></app-buzzer-config-list>
      }

      <!-- Disposition en deux colonnes pour les autres listes -->
      <div class="flex flex-wrap items-start gap-x-8 -mt-4">
        <!-- Colonne gauche -->
        <div class="grow basis-[520px] flex flex-col">
          <app-employee-list [isNested]="true" [nestedData]="employees()"></app-employee-list>
        </div>
        <!-- Colonne droite -->
        <div class="grow basis-[520px] flex flex-col">
          <!-- Cartes d'accès -->
          <app-access-card-list [isNested]="true" [nestedData]="accessCards()"></app-access-card-list>

          <!-- Comptes d'accès -->
          <app-tenant-account-list [isNested]="true" [nestedData]="accounts()"></app-tenant-account-list>
        </div>
      </div>
      }
    </feature-mediator>
  </div>
</div>